//Please add the language resource
const orderLocking = {
  orderNo:'系统单号',
  customOrderNo:'订单号',
  orderUserNo:'业务员',
  serviceType:'是否维护单',
  completionDate: '成交日期',
  presentationDate:'交单日期',
  marketNo: '市场编码',
  marketName: '市场',
  productName: '产品',
  customerName: '客户姓名',
  totalGroupFunds: '总团款',
  wechatDeposit: '微信定金',
  alipayDeposit: '支付宝定金',
  corporateDeposit: '对公定金',
  joiningAreasNo: '对公地接社',
  joiningAreasName: '对公地接社名称',
  collectionAmount: '代收金额',
  operationAreasNo: '操作地接社',
  operationAreasName: '操作地接社名称',
  settlementPrice: '结算价',
  receivables: '应收款',
  companyExpenses: '公司支出',
  areasExpenses: '地接社支出',
  expensesAreasNo: '支出地接社',
  expensesAreasName: '支出地接社名称',
  totalProfit: '总利润',
  travelDate: '行程日期',
  travelDateBegin: '行程开始日期',
  travelDateEnd: '行程结束日期',
  travelStatusNo: '行程状态编号',
  travelStatusName: '行程状态',
  customerIdCard: '身份证',
  customerTel: '手机号',
  remark: '订单备注',
  orderLockedName: '是否锁定',
  depositCheckFlagName: '是否核对定金',
  receivablesCheckFlagName: '是否核对应收款',
  totalProfitCheckFlagName: '是否核对总利润',
  financeRemark: '财务备注',
  presentationFlag: '是否交单',
  depositType: '定金收款方式',
  orderLocked: '是否锁定',
  depositCheckFlag: '是否核对定金',
  receivablesCheckFlag: '是否核对应收款',
  totalProfitCheckFlag: '是否核对总利润',
  documentType: '单据类型',
  msg:{
  }
};
export default orderLocking



// WEBPACK FOOTER //
// ./src/page/financial/orderLocking/lang/orderLocking.en.js